module.exports = __webpack_public_path__ + "img/arrow-right.8947a3cc.svg";